//Get Reducer Call--->
export const getDraftRequest = (page: number, size: number, search: string, collection_day: string) => ({
    type: 'GET_DRAFT_REQUEST',
    payload: { page, size, search, collection_day },
});

export const getDraftSuccess = (data: any) => ({
    type: 'GET_DRAFT_SUCCESS',
    payload: { data },
});

export const getDraftFailure = (data: string) => ({
    type: 'GET_DRAFT_FAILURE',
    payload: { data },
});

export const resetGetDraft = () => ({
    type: 'RESET_GET_DRAFT',
});

//Create Reducer Call--->
export const createDraftRequest = (data: any) => ({
    type: 'CREATE_DRAFT_REQUEST',
    payload: data,
});

export const createDraftSuccess = (data: any) => ({
    type: 'CREATE_DRAFT_SUCCESS',
    payload: { data },
});

export const createDraftFailure = (data: string) => ({
    type: 'CREATE_DRAFT_FAILURE',
    payload: { data },
});

export const resetCreateDraft = () => ({
    type: 'RESET_CREATE_DRAFT',
});

//Update Reducer Call--->
export const updateDraftRequest = (id: string) => ({
    type: 'UPDATE_DRAFT_REQUEST',
    payload: { id },
});

export const updateDraftSuccess = (data: any) => ({
    type: 'UPDATE_DRAFT_SUCCESS',
    payload: { data },
});

export const updateDraftFailure = (data: string) => ({
    type: 'UPDATE_DRAFT_FAILURE',
    payload: { data },
});

export const resetUpdateDraft = () => ({
    type: 'RESET_UPDATE_DRAFT',
});
//Delete Reducer Call--->
export const deleteDraftRequest = (id: string) => ({
    type: 'DELETE_DRAFT_REQUEST',
    payload: { id },
});

export const deleteDraftSuccess = (data: any) => ({
    type: 'DELETE_DRAFT_SUCCESS',
    payload: { data },
});

export const deleteDraftFailure = (data: string) => ({
    type: 'DELETE_DRAFT_FAILURE',
    payload: { data },
});

export const resetDeleteDraft = () => ({
    type: 'RESET_DELETE_DRAFT',
});
